import React, { useContext } from 'react';
import { Smartphone, CreditCard, Timer } from "lucide-react";
import { LanguageContext } from '../context/LanguageContext';
import { Section, SectionHeader } from './ui/Section';
import AppStoreButtons from './ui/AppStoreButtons';

const icons = { Smartphone, CreditCard, Timer };

const HowItWorks = () => {
  const { howItWorksTitle, howItWorksDesc, howItWorksSteps, howItWorksDownload, appStore, googlePlay } = useContext(LanguageContext);

  return (
    <Section tone="mist" id="how-it-works">
      <SectionHeader title={howItWorksTitle} lead={howItWorksDesc} />

      <ol className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
        {howItWorksSteps.map((step, index) => {
          const Icon = icons[step.icon];
          return (
            <li key={index} className="rounded-2xl bg-white p-8">
              <div className="mb-10 flex items-center justify-between">
                <span className="font-display text-5xl font-extrabold leading-none text-brand-teal/25">
                  {String(index + 1).padStart(2, '0')}
                </span>
                {Icon && <Icon className="h-6 w-6 text-brand-teal" aria-hidden="true" />}
              </div>
              <h3 className="mb-2 font-display text-xl font-bold text-brand-navy">{step.title}</h3>
              <p className="mb-0 leading-relaxed text-slate-600">{step.desc}</p>
            </li>
          );
        })}
      </ol>

      <div className="mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="mb-0 font-display text-lg font-bold text-brand-navy">{howItWorksDownload}</p>
        <AppStoreButtons appStore={appStore} googlePlay={googlePlay} />
      </div>
    </Section>
  );
};

export default HowItWorks;
